import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoFramer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 136 48"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#Logo_Framer_svg__a)"
    >
      <path
        d="M.615 2h29.143v14.571H15.186zm0 14.571h14.571l14.572 14.572H.615zm0 14.572h14.571v14.571zM46.2 13.495h11.78v3.744h-7.32v5.202h7.32v3.66h-7.32v6.661H46.2zm14.203 6h4.211v2.78q.33-1.432 1.349-2.202a3.72 3.72 0 0 1 2.312-.798q.661.001 1.1.11v3.909q-.63-.075-1.266-.083-1.732 0-2.614 1.128-.88 1.1-.88 3.304v5.119h-4.21V19.495zm15.62 13.625q-1.925 0-3.358-.909a5.9 5.9 0 0 1-2.146-2.477q-.744-1.596-.745-3.605.001-1.983.772-3.578a5.97 5.97 0 0 1 2.202-2.505q1.457-.908 3.33-.909 1.405 0 2.505.606 1.101.608 1.652 1.652v-1.9h4.183v13.267h-4.183V30.89q-.55.99-1.707 1.624a5.2 5.2 0 0 1-2.505.606m1.212-3.496q1.512 0 2.34-.99.825-.992.825-2.505 0-1.486-.826-2.478-.825-.99-2.34-.99-1.43 0-2.311.963-.853.964-.853 2.505t.853 2.532q.88.963 2.312.963m10.129-10.129h4.21v1.927a3.65 3.65 0 0 1 1.431-1.651q1.02-.633 2.368-.634 3.138 0 4.156 2.45a4.2 4.2 0 0 1 1.679-1.761 4.8 4.8 0 0 1 2.56-.689q4.707 0 4.706 5.395v8.23h-4.238v-7.46q0-1.346-.496-1.98-.495-.633-1.486-.634-1.074 0-1.652.743-.578.716-.578 2.505v6.826h-4.239v-7.487q0-1.348-.495-1.954-.467-.632-1.457-.633-1.102 0-1.68.743-.579.716-.578 2.505v6.826h-4.21zm36.93 5.946q0 .852-.112 1.844h-9.796q.055 1.292.88 1.982.828.687 2.23.688 1.955-.001 2.477-1.184h4.129q-.304 1.954-2.148 3.165-1.816 1.184-4.458 1.184-3.412 0-5.368-1.845-1.926-1.844-1.926-5.146 0-2.147.88-3.716a5.8 5.8 0 0 1 2.505-2.422q1.624-.853 3.773-.854 2.034 0 3.604.799 1.596.799 2.449 2.23.882 1.432.881 3.275m-4.158-.771q-.026-1.32-.743-2.01-.715-.686-2.064-.687-1.348 0-2.147.743-.77.715-.798 1.954zm6.015-5.175h4.211v2.78q.33-1.432 1.349-2.202a3.72 3.72 0 0 1 2.312-.798q.66.001 1.101.11v3.909q-.63-.075-1.266-.083-1.733 0-2.615 1.128-.881 1.1-.881 3.304v5.119h-4.211z" />
    </g>
    <defs>
      <clipPath id="Logo_Framer_svg__a">
        <path
          fill="#fff"
          d="M.615 0h135v48h-135z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoFramer;
